import { StatusComponentMap } from "../../../../../constants"

interface Props {
  status: string
  className?: string
}

const EngagementsStatus = ({
  status,
  className = "mr-2 flex items-center"
}: Props) => <div className={className}>{StatusComponentMap[status]}</div>

export default EngagementsStatus
